import { Injectable } from '@angular/core';
import { ApiService, } from './api.service';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { Settings, TaxRate } from '../models/index';
import { SelectItem } from '../../shared/models/index';

import { getSingleResponse, updateResponse } from './api.service';

import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';

import * as _ from 'lodash';

@Injectable()
export class SettingsService extends ApiService<Settings> {

	protected apiName: string = 'settings';
	protected settings: Settings = new Settings;

	get cdn_url() { return this.settings.cdn_url };
	get base_url() { return this.settings.base_url };
	get offer_footer_text() { return this.settings.offer_footer_text };
	get default_classification() { return this.settings.default_classification };
    get default_pricelist() { return this.settings.default_pricelist };
    get languages() { return this.settings.languages };
    get lowerCaseLanguages() { 
        return this.settings.languages.map(( lang ) => {
            return lang.toLowerCase();
        });
    };
    get taxRates() { return this.settings.tax_rates; }

    getTaxRate(class_id: number): TaxRate { return _.find(this.settings.tax_rates, { class_id: 0+class_id }); }

	constructor(
		public http: HttpClient,
		public translate: TranslateService,
		public confirmationService: ConfirmationService,
		public messageService: MessageService
	) {
		super(http, translate, confirmationService, messageService);
	}

	loadSettings(reload: boolean = false): Observable<Settings> {
		if(!reload && Object.keys(this.settings).length === 0 && this.settings.constructor === Object) {
			return  Observable.create(observer => {
				observer.next(this.settings);
				observer.complete();
			});
		}
		return this.retrieveSettings().map(response => {
			this.settings = response.data;
			return this.settings;
		});
	}

	/**
	 * getSingle(id)
	 * Retrieve single object
	 */
	retrieveSettings(): Observable<getSingleResponse<Settings>> {
		return this.http.get<getSingleResponse<Settings>>(
			this.getBaseUrl('get')
		).retry(this.retries);
	}

	/**
	 *
	 */
	update(data: Settings): Observable<updateResponse<Settings>> {
		return this.http.post<updateResponse<Settings>>(
			this.getBaseUrl('update'),
			data
		);
	}

}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/services/settings.service.ts